import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksSalesInvoiceForm.SalesInvoiceFieldsSection', {
    sectionTitle: 'Invoice details',
    termsField: 'Terms',
    termsPlaceholder: 'Enter terms',
    invoiceDateField: 'Invoice date',
    invoiceDatePlaceholder: 'Enter invoice date',
    dueDateField: 'Due date',
    dueDatePlaceholder: 'Enter due date',
    invoiceNumberField: 'Invoice #',
    invoiceNumberPlaceholder: 'Enter invoice number',
    departmentPlaceholder: 'Select {fieldText}',
    customTransactionNumberTooltip: `
        Leave empty and the number will be filled in automatically after approval.
        Custom Invoice Number may affect an automatic sequence in QuickBooks Online.`,
});
